import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Integration, DeleteIntegrationResponse } from "./types";

export const deleteIntegrationRequest = (integration: Integration) =>
  apiProxyRequest<DeleteIntegrationResponse>(
    integration._links["#delete"]!.href,
    "DELETE"
  );
